module.exports = __webpack_public_path__ + "img/symbol_kutschemitpferd@2x.3a0c453.jpg";